
(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldAutocomplete', fbFieldAutocompleteDirective);

    function fbFieldAutocompleteDirective(lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
            },
            require: 'ngModel',
            controller: fbFieldAutocompleteDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldAutocomplete',
            link: fbFieldAutocompleteDirectiveLink
        };

        function fbFieldAutocompleteDirectiveLink(scope, elem, attr, ctrl) {
            // const vm = scope.vm;
            // if (lodash.has(vm.element, 'attr.attributes')) {
            //     if (!lodash.isEmpty(vm.element, 'attr.attributes')) {
            //         const inputElem = elem.find('input');
            //         lodash.forIn(vm.element.attr.attributes, (value, attr) => {
            //             inputElem.attr(attr, value);
            //         });
            //     }
            // }
            ctrl.$render = function() {
                scope.currentScopeModel = ctrl.$viewValue;
            }

            scope.$watch('currentScopeModel', function() {
                ctrl.$setViewValue(scope.currentScopeModel);
            });

        }
    }

    function fbFieldAutocompleteDirectiveCtrl(FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
        }
    }
})();
